module.exports = __webpack_public_path__ + "img/group-people-white.91db67ae.svg";